module.exports = __webpack_public_path__ + "static/media/EdinburgIL_1-763w.84ac405e.jpg";